import styled, { css } from 'styled-components';

export interface MetricProps {
  small?: boolean;
  large?: boolean;
  largest?: boolean;
}

export const Title = styled('h4')<MetricProps>`
  ${({ small, theme }) => {
    if (small) {
      return css`
        ${theme.typography.xSmall}
        text-transform: uppercase;
        margin-top: 0;
        margin-bottom: ${theme.x1space}rem;
        opacity: 0.7;
      `;
    } else {
      return css`
        ${theme.typography.small}
        margin-top: ${theme.x1space}rem;
        margin-bottom: 0;
      `;
    }
  }}
`;

export const Metric = styled('p')<MetricProps>`
  ${({ theme, large, largest, small }) => {
    if (small) {
      return theme.typography.small;
    } else if (large) {
      return theme.typography.megaStrong;
    } else if (largest) {
      return theme.typography.uberStrong;
    } else {
      return theme.typography.megaStrong;
    }
  }};
  line-height: 1;
  margin: 0;
`;
